import { RuleValidator } from '../types';

export const arrayRules: Record<string, RuleValidator> = {
    array: (value: any): boolean => {
        if (value === undefined || value === null || value === '') return true;
        return Array.isArray(value);
    },

    minItems: (value: any, params: any[]): boolean => {
        if (value === undefined || value === null || value === '') return true;
        if (!Array.isArray(value)) return false;
        return value.length >= params[0];
    },

    maxItems: (value: any, params: any[]): boolean => {
        if (value === undefined || value === null || value === '') return true;
        if (!Array.isArray(value)) return false;
        return value.length <= params[0];
    },

    lengthItems: (value: any, params: any[]): boolean => {
        if (value === undefined || value === null || value === '') return true;
        if (!Array.isArray(value)) return false;
        return value.length === params[0];
    },

    includes: (value: any, params: any[]): boolean => {
        if (value === undefined || value === null || value === '') return true;
        if (!Array.isArray(value)) return false;
        return value.includes(params[0]);
    },

    excludes: (value: any, params: any[]): boolean => {
        if (value === undefined || value === null || value === '') return true;
        if (!Array.isArray(value)) return false;
        return !value.includes(params[0]);
    },

    unique: (value: any): boolean => {
        if (value === undefined || value === null || value === '') return true;
        if (!Array.isArray(value)) return false;
        return value.length === new Set(value).size;
    }
};